<fieldset
  [attr.aria-expanded]="!collapsed"
  [attr.data-cy-tablename]="tableName ? tableName : legend"
  [attr.id]="id"
  [ngClass]="[
    'p-fieldset ui-widget ui-widget-content ui-corner-all',
    toggleable ? 'p-fieldset-toggleable' : '',
    styleClass ? styleClass : '',
  ]"
  [ngStyle]="style">
  @if (isLegendVisible) {
    <legend [ngClass]="['p-fieldset-legend ui-corner-all ui-state-default ui-unselectable-text']">
      <a
        data-cy="fieldset"
        tabindex="0"
        [attr.aria-controls]="id + '-content'"
        [attr.aria-expanded]="!collapsed"
        (click)="handleLegendEvent($event)"
        (keydown.enter)="handleLegendEvent($event)">
        <ng-container [ngTemplateOutlet]="legendContent" />
      </a>
      <ng-template #legendContent>
        <span class="p-fieldset-legend-text" [style.font-size]="overridedCSS?.legendFontSize">{{ legend }}</span>
        @if (toggleable && (!isSingleRow || isReadOnly)) {
          <span [ngClass]="['p-fieldset-toggler pi', collapsed ? 'pi-plus' : 'pi-minus']"></span>
        }

        @if (isSingleRow && !isReadOnly) {
          <span
            class="icon-next-info"
            data-cy="openNewBlade"
            showDelay="250"
            tooltipPosition="top"
            [hideDelay]="250"
            [life]="3000"
            pTooltip="{{ 'menuBarDetails.openNewBlade' | translate }}"></span>
        }

        <ng-content select="p-header" />
      </ng-template>
    </legend>
  }
  <div
    role="region"
    [@fieldsetContent]="
      collapsed
        ? { value: 'hidden', params: { transitionParams: transitionOptions } }
        : { value: 'visible', params: { transitionParams: transitionOptions } }
    "
    [attr.aria-hidden]="collapsed"
    [attr.id]="id + '-content'"
    [ngClass]="[collapsed || animating ? 'p-fieldset-content-wrapper-overflown' : '', 'p-fieldset-content-wrapper']"
    (@fieldsetContent.done)="onToggleDone()">
    <div class="p-fieldset-content" [ngClass]="contentStyleClass">
      <ng-content />
    </div>
  </div>
</fieldset>
